histories-planner
  orders-planner-props(tag-scope="{dataScopeOrder(opts.orderId)}" data-edit="{false}")
  orders-planner-lines(tag-scope="{dataScopeOrder(opts.orderId)}" data-edit="{false}")
  orders-planner-task-editor(if="{true}" tag-scope="orders_planner_task_editor" order-id="{opts.orderId}")
  script(type="typescript").
    this.mixin('histories.planner');
